import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { TextBox } from "../../core/components/textBox";
import { FieldInstance } from "../../core/components/field";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import EditTranslations from "../editTranslations";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react"

export default class EditVehicle extends React.Component<EditVehicleProps, EditVehicleState> {
    private _translations: string[] = null;
    private _options: any = null;
    private _editTranslationsRef: EditTranslations = null;
    private _factory = ComponentHelper.createFactory();
    private _nextId: number;
    private _fullLoaded: boolean;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this._checkData()) {
                        this._save();
                    } else {
                        DialogHelper.alert(this._translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this._fullLoaded = false;
        this.state = { gridData: [], deleteButtonEnabled: false,  dialogOpen: false, currentItem: null };
    }

    private _checkData = () => {
        return !Helper.isNullOrEmpty(this.state.currentItem.Name) || !Helper.isNullOrEmpty(this.state.currentItem.GermanName) ;
    }

    private _getGridData = () => {
        let url = "AssigmentSettings/GetVehicles";
        HTTPService.get<JsonResultClass<Vehicle[]>>(url)
            .then(result => {
                if (result.Code == 0) {
                    this._nextId = result.AdditionalData["NextId"];
                    this._fullLoaded = true;
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _save = () => {
        let url = "AssigmentSettings/SaveVehicles";
        HTTPService.post<JsonResultClass>(url, { model: this.state.currentItem}).then(result => {
            if (result.Code == 0) {
                this._getGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    private _createDialog = () => {
        if (this.state.dialogOpen) {                             
            return (
                <div>
                    <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                        <FullHeightContainer>
                            {this._createTextBox("key")}
                            {this._createTextBox("text")}
                            {this._createTranslationLabel()}
                        </FullHeightContainer>
                    </Dialog>
                    <EditTranslations
                        ref={(r) => this._editTranslationsRef = r}
                        label={Config.translations.editLabel}
                        saveGerman={(value: string) => {
                            let item = this.state.currentItem;
                            item.GermanName = value;
                            this.setState({ currentItem: item });
                        }}
                        canSave={this._checkData}
                    />
                </div>
            );
        } else {
            return (<></>);
        }
    }

    private _createTextBox = (type:"key"|"text") => {
        let props = this._factory.getDefaultTextBoxProps();
        props.field.triggerOnChange = true;
        let label = "";
        if (type === "key") {
            label = this._translations["Standard.Key"];
            props.disabled = true;
            props.value = this.state.currentItem.Id;
        } else {
            label = this._translations["Standard.Name"];
            props.value = this.state.currentItem.Name;
            props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                let item = this.state.currentItem;
                item.Name = value;
                this.setState({ currentItem: item });
            }
        }
        return (
            <FieldInstance label={label} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _createTranslationLabel = () => {
        if (!this.state.currentItem.IsNew) {
            const labelStyle: React.CSSProperties = {
                cursor: "pointer",
                textDecoration: "Underline"
            }
            const divStyle: React.CSSProperties = {
                display: "flex",
                justifyContent: "flex-end",
                fontSize: "10px",
                marginTop: "2px"
            }
            return (
                <FieldInstance noLabel={true}>
                    <div style={divStyle}>
                        <label
                            style={labelStyle}
                            onClick={this._openTranslationsDialog}>{this.props.context.translations["WebSMS.GeneralSettings.UebersetzungenBearbeiten"]}
                        </label>
                    </div>
                </FieldInstance>);
        } else {
            return <></>;
        }
    }

    private _openTranslationsDialog = () => {
        this._editTranslationsRef.openDialog(this.state.currentItem.IsRowId, 428, "value_0", this.state.currentItem.GermanName);
    }

    private _delete = (dataItem: Vehicle) => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let url = "AssigmentSettings/DeleteVehicles";
                HTTPService.post<JsonResultClass>(url, { model: dataItem }).then(result => {
                    if (result.Code == 0) {
                        this._getGridData();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });
    }

    private _openDialog = (dataItem: Vehicle = null) => {
        if (!Helper.hasValue(dataItem)) {
            dataItem = {
                Id: this._nextId,
                IsRowId: 0,
                Name: "",
                GermanName: "",
                IsDeletable: true,
                IsNew: true                
            };
        }
        this.setState({ dialogOpen: true, currentItem: dataItem })
    }

    private _createGrid = () => {
        if (this._fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.deleteButtonEnabled });
            let grid = (
                <Grid data={this.state.gridData} options={this._options} id="generalSettings_Assignment_VehiclesGrid" onSelectionChanged={this._handleSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleSelectedChange = (dataItem: Vehicle) => {
        if (Helper.hasValue(dataItem))
            this.setState({ deleteButtonEnabled: dataItem.IsDeletable });
        else
            this.setState({ deleteButtonEnabled: false });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Vehicle) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem)
                break;
            case (ToolBarStandardButtonType.NEW):
                this._openDialog()
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._delete(dataItem);
                break;
        }
    }

    componentDidMount() {
        this._translations = this.props.context.translations;
        this._options = this.props.context.vehicleGridOptions;        
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        const dialog = this._createDialog();
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};


interface EditVehicleProps {
    entity: any;
    context: ContextGeneralSettingsApp;
}

interface EditVehicleState {
    gridData: Vehicle[];
    deleteButtonEnabled: boolean;
    dialogOpen: boolean;
    currentItem: Vehicle;
}

interface Vehicle {
    Id: number;
    Name: string;
    GermanName: string;
    IsRowId: number;
    IsNew: boolean;
    IsDeletable: boolean;
}